import { IQuickJournalStats } from "../QuickJournalTypes";
import { BuildQuickJournalStoredSnapshot } from "./QuickJournalStatsCore";
import { TRenderable } from "source/app/presentation/Shared/SharedTypes";
import { IQuickJournalEntry } from "../QuickJournalTypes";

export function BuildQuickJournalStats(
    recentEntries: Array<IQuickJournalEntry | TRenderable>,
    weeklyHourlyCounts: Record<string, number> = {}
): IQuickJournalStats {
    const snapshot = BuildQuickJournalStoredSnapshot(
        recentEntries,
        weeklyHourlyCounts
    );

    return {
        dailyCounts: snapshot.dailyCounts,
        weeklyHourlyCounts: snapshot.weeklyHourlyCounts,
    };
}
